import React from 'react'
import { useTranslation } from 'react-i18next'

import ChevronLeftIcon from '../../assets/icons/chevron-left.svg?react'

interface AuthBackButtonProps {
  onClick: () => void
  label?: string
}

export const AuthBackButton: React.FC<AuthBackButtonProps> = ({ onClick, label }) => {
  const { t } = useTranslation()

  return (
    <button
      type="button"
      onClick={onClick}
      className="flex items-center gap-1.5 text-sm text-neutralBlack-500 hover:text-neutralBlack-900 cursor-pointer self-start"
    >
      <ChevronLeftIcon className="size-3.5" />
      <span>{label ?? t('back', { ns: 'auth' })}</span>
    </button>
  )
}
